import { numberToDateString } from "./numberToDateString"

export const getStartEndDateBp = (scheduleSelected, programId) => {
    for (let i = 0; i < scheduleSelected.length; i++) {
        if (scheduleSelected[i].programId === programId) {
            return numberToDateString(scheduleSelected[i].startDate) + ' s/d ' + numberToDateString(scheduleSelected[i].endDate)
        }
    }
}